export const CUSTOMER_TYPE_PRIVATE = 'private';
export const CUSTOMER_TYPE_BUSINESS = 'business';
const AUTH_TYPE_DEALER = 'dealerService';
export const resolveIndicatorValue = (speedIndicatorValues, offerDownloadSpeed) => {
    let value = 25;
    if (speedIndicatorValues && offerDownloadSpeed) {
        for (const indicatorValue of speedIndicatorValues) {
            if (offerDownloadSpeed >= indicatorValue.minSpeed) {
                value = indicatorValue.indicatorValue;
            }
            else {
                break;
            }
        }
    }
    return value;
};
const getCookieValue = (name) => {
    const pair = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    if (!!pair) {
        return pair[1];
    }
    return null;
};
export const getCustomerIdFromAuth = (auth) => {
    var _a;
    return (_a = auth === null || auth === void 0 ? void 0 : auth.customer) === null || _a === void 0 ? void 0 : _a.customerId;
};
export const getSegment = (auth) => {
    if (auth === null || auth === void 0 ? void 0 : auth.customer) {
        return auth.customer.type === 'B2B' ? CUSTOMER_TYPE_BUSINESS : CUSTOMER_TYPE_PRIVATE;
    }
    const headerSegmentCookie = getCookieValue('segment');
    if (headerSegmentCookie) {
        return headerSegmentCookie.toUpperCase() === 'B2B' ? CUSTOMER_TYPE_BUSINESS : CUSTOMER_TYPE_PRIVATE;
    }
    return CUSTOMER_TYPE_PRIVATE;
};
export const getIsDealerFromAuth = (auth) => {
    return (auth === null || auth === void 0 ? void 0 : auth.authType) === AUTH_TYPE_DEALER;
};
export const isDealerWithoutCustomer = (isDealer, customerId) => {
    return isDealer && !customerId;
};
export const resolveAddressCode = (address, room) => {
    if (room && room.roomId) {
        return `${room.roomId}|R`;
    }
    if (address.buildingId) {
        return `${address.buildingId}|B`;
    }
    return `${address.id}|A`;
};
